var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializePublicKeyToBase64 } from "@hyper-hyper-space/hhs3_mvt";
export function resolveValue(expr, context) {
    return __awaiter(this, void 0, void 0, function* () {
        if (expr.kind === 'literal')
            return expr.value;
        if (expr.kind === 'hash') {
            throw new Error('#prefix in VALUES is resolved by the binder for REFERENCES columns');
        }
        if (expr.kind === 'variable') {
            if (expr.field !== undefined)
                throw new Error('$row.<column> is only supported in allow rule predicates');
            return context.resolveVariable(expr.name);
        }
        if (expr.kind === 'call') {
            if (expr.name === 'publicKey') {
                if (expr.args.length !== 1)
                    throw new Error('publicKey() expects exactly one argument');
                return publicKeyString(yield resolveValue(expr.args[0], context));
            }
            throw new Error(`Unknown value function '${expr.name}'`);
        }
        throw new Error('Unexpected value expression');
    });
}
export function asJsonLiteral(value) {
    if (value === null)
        throw new Error('NULL is not a JSON literal in RDb payloads');
    if (isIdentity(value))
        return value.keyId;
    if (isKeyRecord(value))
        return value.keyId;
    if (isKeyIdObject(value))
        return value.keyId;
    return value;
}
export function asKeyId(value) {
    if (value === undefined || value === null)
        return undefined;
    if (typeof value === 'string')
        return value;
    if (isIdentity(value))
        return value.keyId;
    if (isKeyRecord(value))
        return value.keyId;
    if (isKeyIdObject(value))
        return value.keyId;
    throw new Error('Expected key id or identity value');
}
export function asIdentity(value) {
    return value !== undefined && isIdentity(value) ? value : undefined;
}
export function asCreator(value) {
    if (isIdentity(value))
        return { keyId: value.keyId, publicKey: value.publicKey };
    if (isKeyRecord(value) && value.publicKey !== undefined) {
        return { keyId: value.keyId, publicKey: value.publicKey };
    }
    throw new Error('Expected identity or creator value');
}
export function resolveCreator(expr, context) {
    return __awaiter(this, void 0, void 0, function* () {
        if (expr.kind === 'variable') {
            return asCreator(yield resolveValue(expr, context));
        }
        if (expr.kind === 'hash') {
            if (context.resolvePublicKey === undefined) {
                throw new Error('CREATORS #prefix requires a keystore host');
            }
            return resolveCreatorKey(context, `#${expr.prefix}`, expr.prefix);
        }
        if (expr.kind === 'literal' && typeof expr.value === 'string') {
            if (context.resolvePublicKey === undefined) {
                throw new Error('CREATORS key-id literal requires a keystore host');
            }
            return resolveCreatorKey(context, `'${expr.value}'`, expr.value);
        }
        return asCreator(yield resolveValue(expr, context));
    });
}
function resolveCreatorKey(context, displayRef, labelOrPrefix) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield context.resolvePublicKey(labelOrPrefix);
        }
        catch (e) {
            const message = e instanceof Error ? e.message : String(e);
            throw new Error(`${message} (CREATORS ${displayRef})`);
        }
    });
}
function publicKeyString(value) {
    if (isIdentity(value) || isKeyRecord(value)) {
        if (value.publicKey === undefined)
            throw new Error('publicKey() requires an identity or public key record');
        return serializePublicKeyToBase64(value.publicKey);
    }
    throw new Error('publicKey() requires an identity or public key record');
}
function isIdentity(value) {
    return typeof value === 'object' && value !== null && 'keyId' in value && 'publicKey' in value && 'secretKey' in value;
}
function isKeyRecord(value) {
    return typeof value === 'object' && value !== null && 'keyId' in value && !('kind' in value);
}
function isKeyIdObject(value) {
    return typeof value === 'object' && value !== null && 'kind' in value && value.kind === 'key-id';
}
